<drx-ui-public-frame
  [appImage]="appImage"
  [versionString]="versionString"
  [stageName]="stageName"
>
  <router-outlet></router-outlet>
</drx-ui-public-frame>
